"use client";

import React from "react";
import styles from "./ColorOption.module.scss";
import { ColorVariant } from "@components/organisms/ColorSelectionModal/colorSelectionData";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import { formatFullDate } from "@utils/formatDate";

interface ColorOptionProps {
  color: ColorVariant;
  isSelected: boolean;
  onClick: (color: ColorVariant) => void;
  className?: string;
  hidePricingAndDelivery?: boolean;
}

export default function ColorOption({
  color,
  isSelected,
  onClick,
  className,
  hidePricingAndDelivery = false,
}: ColorOptionProps) {
  const handleClick = () => {
    onClick(color);
  };

  return (
    <div
      className={`${styles.colorOption} ${isSelected ? styles.selected : ""} ${
        className || ""
      }`}
      onClick={handleClick}
    >
      {/* Color Indicator */}
      <div className={styles.colorIndicator}>
        <div
          className={styles.colorCircle}
          style={{ backgroundColor: color.colorCode }}
        />
      </div>

      {/* Color Details */}
      <div className={styles.colorDetails}>
        <div className={styles.colorInfo}>
          <h4 className={styles.colorName}>{color.name}</h4>

          {/* Price Section - Only show if not hidden */}
          {!hidePricingAndDelivery && (
            <div className={styles.priceSection}>
              <span className={styles.currentPrice}>{color.currentPrice}</span>
              <span className={styles.originalPrice}>
                {color.originalPrice}
              </span>
              <span className={styles.savings}>Save {color.savings}</span>
            </div>
          )}
        </div>

        {/* Delivery Badge - Only show if not hidden */}
        {!hidePricingAndDelivery && (
          <div
            className={`${styles.deliveryBadge} ${
              color.isExpressDelivery ? styles.expressDelivery : ""
            }`}
          >
            {color.isExpressDelivery && (
              <Image
                src={`${assetLoader()}/icons/delivery-icon.svg`}
                alt="Delivery badge"
                width={24}
                height={24}
                loading="lazy"
                className={styles.deliveryIcon}
              />
            )}
            <span className={styles.deliveryText}>
              {color.isExpressDelivery
                ? `Express delivery ${
                    color?.waitingPeriod
                      ? `by ${formatFullDate(color.waitingPeriod)}`
                      : ""
                  }`
                : `Standard delivery ${
                    color?.waitingPeriod
                      ? `by ${formatFullDate(color.waitingPeriod)}`
                      : ""
                  }`}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
